// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__36PsQ","colMaxWidth":"Table_colMaxWidth__22fJv"};